import Invoice from "./Invoice";
import Status from "./Status";

export default class InvoiceList {
  constructor(
    public readonly invoices: Invoice[],
    public readonly status: Status,
  ) {}
}
